import Main from "./containers/Main.jsx";

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
